'use client';

import { type ComponentPropsWithoutRef, type Ref, useState } from 'react';

import classnames from 'classnames';
import { IoCloudOfflineOutline } from 'react-icons/io5';

import type { BaseComponentProps } from '../../base-component.types';
import { Icon } from '../../icon';
import { Skeleton } from '../../skeleton';

import styles from './QuestionImage.module.scss';

type QuestionImageProps = ComponentPropsWithoutRef<'img'> & BaseComponentProps;

export function QuestionImage({
  style,
  className,
  testId = 'ui-question-image',
  ref,
  ...rest
}: QuestionImageProps & { ref?: Ref<HTMLImageElement> }) {
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState(false);

  return (
    <div className={styles['image-wrapper']}>
      {!loaded && !error && (
        <Skeleton
          containerClassName={styles['skeleton']}
          className={styles['skeleton__shimmer']}
          inline={true}
        />
      )}

      {error && (
        <Icon
          icon={<IoCloudOfflineOutline />}
          className={styles['icon--danger']}
          role="img"
          aria-label="No se pudo cargar la imagen"
        />
      )}

      <img
        key={typeof rest.src === 'string' ? rest.src : undefined}
        ref={ref}
        style={style}
        className={classnames(styles['image'], className)}
        onLoad={() => setLoaded(true)}
        onError={() => setError(true)}
        data-testid={testId}
        hidden={!loaded || error}
        alt="Imagen de la pregunta"
        {...rest}
      />
    </div>
  );
}
